import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { fetchJockeyDetailStats } from "../../redux/getReducer/getLatestResultJockeyStats";
import { fetchjockeymodalstats } from "../../redux/getReducer/getJockeyModalstats";
import Moment from "react-moment";
import PleaseWait from "../Reuseable/PleaseWait";
import arrow1 from "../../assets/image 13 (Traced).png";
import { truncateRaceType, toTitleCase } from "../../service/stringUtils";
import VideoFrame from "../Modal/VideoFrame";
import RaceModal from "../Modal/RaceModal";
import { IoMdPlay } from "react-icons/io";
import { MdKeyboardArrowDown } from "react-icons/md";
import ScrollContainer from "react-indiana-drag-scroll";
import { Accordion, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";

const Stats = ({ id }) => {
  const { data: JockeyDetailStats } = useSelector((state) => state.JockeyDetailStats);
  const { data: jockeymodalstats } = useSelector((state) => state.jockeymodalstats);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [year, setyear] = useState("");

  const [shows, setShows] = useState(false);
  const [modaldatas, setmodaldatas] = useState();
  const handleCloses = () => setShows(false);
  const handleShows = async (data) => {
    setmodaldatas(data);
    await setShows(true);
  };

  const [showRace, setShowRace] = useState(false);
  const [modaldataRace, setmodaldataRace] = useState();
  const handleCloseRace = () => setShowRace(false);
  const handleShowRace = (data) => { const id = data?._id || data; if (id) navigate("/race-detail?" + id); };

  const handleShowHorse = (id) => {
    if (id) navigate("/horse-detail?" + id);
  };
  
  const { t } = useTranslation();
  const cookiedata = Cookies.get("i18next");
  const FirstLetter = (data) => data ? data.substring(0, 1) : "";

  useEffect(() => {
    dispatch(fetchJockeyDetailStats({ year, id }));
    dispatch(fetchjockeymodalstats({ id }));
  }, [dispatch, id]);

  const handleTrainerRecord = (year) => {
    dispatch(fetchJockeyDetailStats({ year, id }));
  };

  function distanceLabel(distance, rank) {
    const d = parseFloat(distance);
    if (d.toFixed(2) > 25) return "Dist";
    else if (d.toFixed(2) == 0.05 && rank < 80) return "SHd";
    else if (d.toFixed(2) == 0.10 && rank < 80) return "Hd";
    else if (d.toFixed(2) == 0.25 && rank < 80) return "Nk";
    else if (d.toFixed(2) == 0.01 && rank < 80) return "Ns";
    else if (d.toFixed(2) == 0.00 && rank < 80) return rank === 1 ? 0 : "Dh";
    else return distance;
  }

  // Common Header for the Inner 16-Column Table
  const InnerTableHeader = () => (
    <div className="stats-new-inner-thead">
      <div>{t("Date")}</div><div>{t("Crs")}</div><div>{t("Horse Name")}</div><div>{t("Dist")}</div><div>{t("RT")}</div><div>{t("Time")}</div><div>{t("Jockey")}</div><div>{t("Wgt")}</div><div>{t("FP")}</div><div>{t("Len")}</div><div>{t("RN")}</div><div>{t("BtBy")}</div><div>{t("Kgs")}</div><div>{t("Draw")}</div><div>{t("OR")}</div><div>{t("Link")}</div>
    </div>
  );

  // Common Row for the Inner Table
  const InnerTableRow = (item, i) => {
    const ground = item.RaceResultData?.TrackLengthData?.GroundTypeModelData?.NameEn;
    const rowColor = ground === "Dirt" ? "#e3d4ca" : ground === "Turf" ? "#cbedba" : "#949494";

    return (
      <div key={i} className="stats-new-inner-row" style={{ backgroundColor: rowColor, color: '#343433' }}>
        <div onClick={() => handleShowRace(item.RaceID)} className="new-clickable-white">
          <Moment format="DD/MM/YYYY">{item.RaceResultData?.StartTime}</Moment>
        </div>
        <div>
          {cookiedata === "en" ? item.RaceResultData?.RaceCourseData?.AbbrevEn : item.RaceResultData?.RaceCourseData?.AbbrevAr}({FirstLetter(cookiedata === "en" ? ground : item.RaceResultData?.TrackLengthData?.GroundTypeModelData?.NameAr)})
        </div>
        <div className="new-clickable-white" onClick={() => handleShowHorse(item.HorseIDData?._id)}>
          {cookiedata === "en" ? toTitleCase(item.HorseIDData?.NameEn || "-") : (item.HorseIDData?.NameAr || "-")}
        </div>
        <div>{item.RaceResultData?.TrackLengthData?.TrackLength || item.Distance || "-"}</div>
        <div className="stats-new-truncate">{cookiedata === "en" ? toTitleCase(truncateRaceType(item.RaceResultData?.RaceTypeModelData?.NameEn)) : item.RaceResultData?.RaceTypeModelData?.NameAr}</div>
        <div>{item.RaceTime || "-"}</div>
        <div>{cookiedata === "en" ? toTitleCase(item.JockeyOnRaceDataResult?.ShortNameEn) : item.JockeyOnRaceDataResult?.ShortNameAr}</div>
        <div>{item.RaceResultData?.RacehorsesData?.[0]?.JockeyRaceWeight || item.JockeyRaceWeight || "-"}</div>
        <div>{cookiedata === "en" ? toTitleCase(item.FinalPositionDataHorse?.NameEn) : item.FinalPositionDataHorse?.NameAr}</div>
        <div>{distanceLabel(item.Distance, item.FinalPositionDataHorse?.Rank)}</div>
        <div>{item.RaceResultData?.Runners || item.Runners || "-"}</div>
        <div className="stats-new-truncate new-clickable-white" onClick={() => handleShowHorse(item.BeatenByData?._id || item.BeatenByData)}>
          {item.BeatenByData ? toTitleCase(cookiedata === "en" ? item.BeatenByData?.NameEn : item.BeatenByData?.NameAr) : toTitleCase(cookiedata === "en" ? item.HorseIDData?.HorseBeatenByEnglishName : item.HorseIDData?.HorseBeatenByArabicName)}
        </div>
        <div>{item.BeatenByData?.WinningHorseJockeyWeight?.toFixed(1) || 0}</div>
        <div>{item.RaceResultData?.Draw || item.HorseNo || item.GateNo || "-"}</div>
        <div>{item.Rating || 0}</div>
        <div onClick={() => handleShows(item.VideoLink)} className="owner-new-mini-play"><IoMdPlay /></div>
      </div>
    );
  };

  return (
    <div className="my-new-stats-tab-wrapper">
      {/* --- OUTER MAIN HEADER --- */}
      <div className="my-new-stats-thead">
        <div>{t("Year")}</div>
        <div>{t("Runs")}</div>
        <div>{t("Wins")}</div>
        <div>{t("Second")}</div>
        <div>{t("Third")}</div>
        <div>{t("Fourth")}</div>
        <div>{t("Fifth")}</div>
        <div>{t("Earning")}</div>
        <div>{t("Wins")}%</div>
        <div>{t("Place")}%</div>
        <div></div>
      </div>

      <Accordion className="my-new-stats-accordion-container">
        {/* --- OVERALL SECTION --- */}
        <Accordion.Item className="stats-new-acc-item" eventKey="overall">
          <Accordion.Header className="stats-new-header-custom">
            <div className="my-new-stats-header-grid">
              <div className="new-bold-blue">OverAll</div>
              <div>{jockeymodalstats.OverAll?.Runs}</div>
              <div>{jockeymodalstats.OverAll?.wins}</div>
              <div>{jockeymodalstats.OverAll?.second}</div>
              <div>{jockeymodalstats.OverAll?.third}</div>
              <div>{jockeymodalstats.OverAll?.fourth}</div>
              <div>{jockeymodalstats.OverAll?.fifth}</div>
              <div className="new-bold">{Number(jockeymodalstats.OverAll?.earning || 0).toLocaleString()}</div>
              <div>{Number(jockeymodalstats.OverAll?.winspercentage || 0).toFixed(2)}</div>
              <div>{Number(jockeymodalstats.OverAll?.placespercentage || 0).toFixed(2)}</div>
              <div className="stats-new-arrow-icon"><MdKeyboardArrowDown /></div>
            </div>
          </Accordion.Header>
          <Accordion.Body>
            <ScrollContainer>
              <div className="stats-new-inner-grid-table">
                <InnerTableHeader />
                {(!JockeyDetailStats) ? <PleaseWait /> : JockeyDetailStats.map((item, i) => InnerTableRow(item, i))}
              </div>
            </ScrollContainer>
          </Accordion.Body>
        </Accordion.Item>

        {/* --- YEARLY DATA SECTIONS --- */}
        {jockeymodalstats?.data && jockeymodalstats.data.map((item, idx) => (
          <Accordion.Item 
            key={idx} 
            className="stats-new-acc-item" 
            eventKey={idx.toString()}
            onClick={() => handleTrainerRecord(item.Years)}
          >
            <Accordion.Header className="stats-new-header-custom">
              <div className="my-new-stats-header-grid">
                <div className="new-bold-blue">{item?.Years}</div>
                <div>{item.Detail?.Runs}</div>
                <div>{item.Detail?.wins}</div>
                <div>{item.Detail?.second}</div>
                <div>{item.Detail?.third}</div>
                <div>{item.Detail?.fourth}</div>
                <div>{item.Detail?.fifth}</div>
                <div className="new-bold">{Number(item.Detail?.earning || 0).toLocaleString()}</div>
                <div>{Number(item.Detail?.winspercentage || 0).toFixed(2)}</div>
                <div>{Number(item.Detail?.placespercentage || 0).toFixed(2)}</div>
                <div className="stats-new-arrow-icon"><MdKeyboardArrowDown /></div>
              </div>
            </Accordion.Header>
            <Accordion.Body>
              <ScrollContainer>
                <div className="stats-new-inner-grid-table">
                  <InnerTableHeader />
                  {(!JockeyDetailStats) ? <PleaseWait /> : JockeyDetailStats.map((row, i) => InnerTableRow(row, i))}
                </div>
              </ScrollContainer>
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>

      {/* --- MODALS --- */}
      <Modal show={shows} onHide={handleCloses} size="lg" centered>
        <Modal.Header className="popupheader" closeButton></Modal.Header>
        <Modal.Body><VideoFrame data={modaldatas} /></Modal.Body>
      </Modal>
      <Modal show={showRace} onHide={handleCloseRace} size="lg" centered>
        <Modal.Header className="popupheader" closeButton></Modal.Header>
        <Modal.Body><RaceModal id={modaldataRace} /></Modal.Body>
      </Modal>
    </div>
  );
};

export default Stats;